import $ from "jquery";
import Constants from "./Constants";
import GigyaManager from "./GigyaManager";
import Cookies from "js-cookie";

class RestManager {

    testConnection(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUser().then((user) => {
                let obj = {
                    token: Constants.API_TOKEN
                }
                $.ajax(Constants.API_ENDPOINT + '/api/test-connection', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj),
                    beforeSend: (xhr) => {
                    }
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    }else{
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    userStatus(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();

                var ch = user.data[Constants.CH_PROMO];
                if(typeof ch == "undefined" || ch == null || ch == ""){
                    reject();
                }

                if(!Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7)+"_"+user.UID.substring(0,7))){
                    try{
                        let login = await this.login(user);
                    }catch (err) {
                        if(err.status.errors.data.code == "LOGINFAIL"){
                            await this.registerUser(user);
                        }else{
                            throw err;
                        }
                    }
                }

                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token:  Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    }
                }
                $.ajax(Constants.API_ENDPOINT + '/api/utente/area-personale', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"
                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    playReceipt(formJson){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();

                if(!Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))){
                    await this.login(user);
                }

                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token:  Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    }
                }
                $.extend(payload, formJson);

                $.ajax(Constants.API_ENDPOINT + '/api/partecipa/documento-di-acquisto/gioca', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"
                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    uploadImage(type, file){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                try{
                    let jwt = await GigyaManager.getJWT();

                    var ch = user.data[Constants.CH_PROMO];
                    if(typeof ch == "undefined" || ch == null || ch == ""){
                        try{
                            let login = await this.login(user);
                        }catch (err) {
                            if(err.status.errors.data.code == "LOGINFAIL"){
                                await this.registerUser(user);
                            }else{
                                throw err;
                            }
                        }

                    }

                    if(!Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))){
                        console.log("Cookie not set!"); //TODO remove
                        await this.login(user);
                    }

                    let payload = {
                        securitydata: {
                                apitoken: Constants.API_TOKEN,
                                guid: user.UID,
                                gst: jwt.id_token,
                                auth_token: Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                        },
                        basedata: {
                            source: type,
                        },
                        customdata: []
                    }


                    let formData = new FormData();
                    formData.append("fields", JSON.stringify(payload));
                    formData.append("file", file);

                    $.ajax(Constants.API_ENDPOINT + '/api/carica/file', {
                        type: "POST",
                        contentType: false,
                        processData: false,
                        data: formData
                    }).done((resp) => {
                        if(resp.status.runtime.completed){
                            resolve(resp);
                        } else {
                            reject(resp);
                        }

                    }).fail((resp) => {
                        reject(resp);
                    });

                } catch (e) {
                    console.log("Catch Generale");
                    console.log(e);
                    reject(e);
                }
            });
        });
    }

    async registerUser(user){
        let jwt = GigyaManager.getJWT();
        let data = {
            securitydata: {
                apitoken: Constants.API_TOKEN,
                guid: user.UID,
                gst: jwt.id_token
            },
            basedata: {
                "user_email": user.profile.email,
                "user_password": user.UID,
                "user_first_name": user.profile.firstName,
                "user_last_name": user.profile.lastName
            },
            customdata: []
        }
        return new Promise((resolve, reject) => {
            $.ajax(Constants.API_ENDPOINT + '/api/utente/registrazione', {
                type: "POST",
                dataType: "json",
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8"
            }).done((resp) => {
                if (resp.status.runtime.completed) {
                    let activationData = {
                        securitydata: {
                            apitoken: Constants.API_TOKEN,
                            guid: user.UID,
                            gst: jwt.id_token
                        },
                        basedata: {
                            "user_email": user.profile.email,
                            "activation_token": resp.response.data.activation_token,
                        },
                        customdata: []
                    }

                    $.ajax(Constants.API_ENDPOINT + '/api/utente/attivazione', {
                        type: "POST",
                        dataType: "json",
                        data: JSON.stringify(activationData),
                    }).done((resp) => {
                        if(resp.status.runtime.completed){
                            resolve();
                        }else{
                            reject(resp);
                        }
                    }).fail((resp)=>{
                        reject(resp);
                    })

                    resolve(resp);
                } else {
                    reject(resp);
                }

            }).fail((resp) => {
                reject(resp);
            });
        });
    }


    async login(user) {
        let jwt = GigyaManager.getJWT();
        let data = {
            securitydata: {
                apitoken: Constants.API_TOKEN,
                guid: user.UID,
                gst: jwt.id_token
            },
            basedata: {
                "user_email": user.profile.email,
                "user_password": user.UID
            },
            customdata: []
        }
        return new Promise((resolve, reject) => {
            $.ajax(Constants.API_ENDPOINT + '/api/utente/login', {
                type: "POST",
                dataType: "json",
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8"

            }).done((resp) => {
                if (resp.status.runtime.completed) {
                    Cookies.set(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7), resp.response.data.auth_token, { expires: 0.04})
                    resolve(resp);
                } else {
                    reject(resp);
                }

            }).fail((resp) => {
                reject(resp);
            });
        });
    }


    prizeRequest(form){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token:  Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    }
                }
                $.extend(payload, form);
                $.ajax(Constants.API_ENDPOINT + '/api/partecipa/hai-vinto/completa-i-tuoi-dati', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"

                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    associateTelephone(telephone){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();

                try{
                    let login = await this.login(user);
                }catch (err) {
                    if(err.status.errors.data.code == "LOGINFAIL"){
                        await this.registerUser(user);
                    }else{
                        reject(err);
                    }
                }

                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token: Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    },
                    basedata: {
                        phone: telephone,
                    },
                    customdata: []
                }


                $.ajax(Constants.API_ENDPOINT + '/api/utente/unisci-profilo', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"
                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    getProvinces(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();

                var ch = user.data[Constants.CH_PROMO];
                if(typeof ch == "undefined" || ch == null || ch == ""){
                    reject();
                }

                if(!Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))){
                    await this.login(user);
                }

                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token:  Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    },
                    basedata: {
                        regionid: 0
                    }
                }
                $.ajax(Constants.API_ENDPOINT + '/api/data/province/elenco', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"
                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    getCities(idprovince){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();

                var ch = user.data[Constants.CH_PROMO];
                if(typeof ch == "undefined" || ch == null || ch == ""){
                    reject();
                }

                if(!Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))){
                    await this.login(user);
                }

                let payload = {
                    securitydata: {
                        apitoken: Constants.API_TOKEN,
                        guid: user.UID,
                        gst: jwt.id_token,
                        auth_token:  Cookies.get(Constants.WINNING_SESSION_COOKIE_NAME+"_"+user.UID.substring(0,7))
                    },
                    basedata: {
                        provinceid: idprovince
                    }
                }
                $.ajax(Constants.API_ENDPOINT + '/api/data/citta/elenco', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(payload),
                    contentType: "application/json; charset=utf-8"
                }).done((resp) => {
                    if(resp.status.runtime.completed){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }


}

export default new RestManager();
